module.exports = __webpack_public_path__ + "static/media/city-sml.974a0b88.jpg";